import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
export interface PowerplantState {
  _id: string | undefined,
  name: string | undefined,
}

// Define the initial state using that type
const initialState: PowerplantState = {
  _id: undefined,
  name: undefined
};

const powerplantSlice = createSlice({
  name: 'powerplant',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // get(state) { // In Redux, this action is typically unnecessary because the current state can always be accessed with a selector.
    //   return state;
    // },
    // Use the PayloadAction type to declare the contents of `action.payload`
    // It doesn't have to be the <PowerplantState>. It can be anything. E.g <number> or <string>
    clear(state) {
      state._id = undefined;
      state.name = undefined;
      localStorage.removeItem('selectedPowerplant');
    },
    set(state, action: PayloadAction<PowerplantState>) {
      state._id = action.payload._id;
      state.name = action.payload.name;
      localStorage.setItem('selectedPowerplant', JSON.stringify(state));
    },
  }
});

export const powerplantActions = powerplantSlice.actions;
export default powerplantSlice;
